function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15.4",
  viewBox: "0 0 15 15.4",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 5.02a2.68 2.68 0 102.68 2.68A2.68 2.68 0 007.5 5.02zm5.78 2.68a5.54 5.54 0 01-.05.75l1.63 1.28a.39.39 0 01.09.5l-1.54 2.65a.39.39 0 01-.48.17l-1.91-.77a5.91 5.91 0 01-1.3.76l-.3 2.03a.4.4 0 01-.38.33H5.96a.4.4 0 01-.39-.32l-.28-2.03a5.67 5.67 0 01-1.3-.76l-1.92.77a.39.39 0 01-.47-.17L.05 10.23a.39.39 0 01.09-.5l1.63-1.27a5.84 5.84 0 01-.06-.76 5.54 5.54 0 01.06-.75L.14 5.68a.39.39 0 01-.1-.5L1.6 2.52a.39.39 0 01.47-.17l1.92.77a5.91 5.91 0 011.3-.75L5.57.33A.4.4 0 015.96 0h3.08a.4.4 0 01.39.32l.28 2.03a5.67 5.67 0 011.3.76l1.92-.77a.39.39 0 01.47.17l1.55 2.66a.39.39 0 01-.09.5l-1.63 1.27a5.85 5.85 0 01.05.76z"
})));